import getActiveSheet from '@/spreadsheets/getActiveSheet'
import separateColumnSet from '@/utils/comparables/separateColumnSet'
import { INDUSTRY_GROUP_GICS_LABEL } from '@/utils/comparables/constants'

export default (
  compsType = 'company',
  { outliersIncluded, classificationSelected, fxSetting, sheetName, customColumnSet, sortInfo, filterItemMap },
) => {
  const sheet = getActiveSheet()
  if (!sheet) {
    return
  }
  const { columns, columnConfig } = separateColumnSet(customColumnSet)
  const compsProps = {
    type: compsType,
    filterItemMap,
    sortInfo: sortInfo,
    columnConfig,
    columns,
    activeSheet: sheetName ?? getActiveSheet().name(),
    currency: fxSetting,
  }
  if (compsType === 'sector') {
    compsProps.gicsLevel = classificationSelected || INDUSTRY_GROUP_GICS_LABEL
    compsProps.outliersIncluded = outliersIncluded || false
    delete compsProps.activeSheet
  }
  if (['market', 'movers'].includes(compsType)) {
    delete compsProps.activeSheet
  }
  return compsProps
}
